/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.5.22",
    versionName: "0.3.0-nightly.2026.5.22",
    versionChannel: "nightly",
    buildDate: "2026-05-22T00:35:46.345Z",
    commitHash: "7fdef595f853902ddb6532f581d8bfbdd8104be1",
};
